/** Menú lateral: convierte iconoProceso (string del backend) en iconos de react-icons vía iconMap y define el ítem secundario de Configuración. */
import React from "react";
import {
  MdSettings,
  MdHome,
  MdCalendarMonth,
  MdShoppingCart,
  MdPerson,
  MdDirectionsCar,
  MdBuild,
  MdDescription,
  MdPeople,
  MdAttachMoney,
  MdCheckBox,
  MdApps,
  MdHandyman,
  MdEngineering,
  MdArticle,
} from "react-icons/md";

export const iconMap: Record<string, React.ReactNode> = {
  MdHome: <MdHome size={18} />,
  MdCalendarMonth: <MdCalendarMonth size={18} />,
  MdShoppingCart: <MdShoppingCart size={18} />,
  MdPerson: <MdPerson size={18} />,
  MdDirectionsCar: <MdDirectionsCar size={18} />,
  MdBuild: <MdBuild size={18} />,
  MdDescription: <MdDescription size={18} />,
  MdPeople: <MdPeople size={18} />,
  MdAttachMoney: <MdAttachMoney size={18} />,
  MdCheckBox: <MdCheckBox size={18} />,
  MdHandyman: <MdHandyman size={18} />,
  MdEngineering: <MdEngineering size={18} />,
  MdApps: <MdApps size={18} />,
  MdSettings: <MdSettings size={18} />,
  MdArticle: <MdArticle size={18} />,
};

export const secondaryItems = [
  {
    key: "9",
    icon: <MdSettings size={18} />,
    label: "Configuración",
    title: "Próximamente",
    disabled: true,
  },
];
